import { AppSettingsCardProps } from './types';
import { cn } from '@/lib/utils';
import { Moon } from 'lucide-react';

const AppSettingsCard = (props: AppSettingsCardProps) => {
  const {
    isDark,
    toggle
  } = props;

  return (
    <article className="flex items-center justify-between px-4 py-2 rounded-2xl border border-border-strong bg-surface">
      <div className="flex min-w-0 items-center gap-2">
        <div className="flex size-8 shrink-0 items-center justify-center rounded-[8px] bg-[#13100d0d] dark:bg-[#ffffff0d]">
          <Moon className="size-4 text-foreground" />
        </div>
        <span className="min-w-0 truncate text-sm font-normal leading-5 text-foreground">Темная тема</span>
      </div>
      <button
        aria-checked={isDark}
        aria-label="Темная тема"
        className={cn(
          'relative flex h-5 w-11 shrink-0 items-center px-[2px] py-1',
          'rounded-full border border-accent/50 bg-accent/20',
          'transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
          isDark && 'justify-end border-accent bg-accent'
        )}
        onClick={toggle}
        role="switch"
        type="button"
      >
        <span
          className={cn(
            'block h-3 w-5',
            'rounded-full bg-accent',
            'transition-transform',
            isDark && 'bg-background'
          )}
        />
      </button>
    </article>
  );
};

export default AppSettingsCard;